import React from "react";
import ECLTableCell from "./ECLTableCell";
import ECLDropDown from "../../ECLDropDown/ECLDropDown";
import ECLThemeImage from "../../ECLThemeImage/ECLThemeImage";
import { translate } from "../../../../utilities/Translate";

export default function RightColumns({
   row,
   index,
   tableSettings,
   columnSettings,
   instanceId,
   style = null,
}) {
   return (
      <div
         key={index}
         className={
            "sticky-row" +
            (index % 2 !== 0 ? " table-alt-row" : "") +
            (tableSettings.hoverIndicator ? " table-row-hover" : "")
         }
         style={
            style
               ? { ...style, display: "flex" }
               : {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: tableSettings.rowHeight + "px",
                 }
         }
         role="row"
      >
         {tableSettings.rightStickyCols &&
            tableSettings.rightStickyCols.map((key, i) => {
               const columnIndex = columnSettings.findIndex(
                  (c) => c.id === key,
               );
               return (
                  <ECLTableCell
                     columnSettings={columnSettings}
                     tableIndex={index}
                     columnInfo={columnSettings[columnIndex]}
                     hide={
                        tableSettings.columnHide
                           ? tableSettings.columnHide.includes(key)
                           : false
                     }
                     content={row.row[columnIndex]}
                     key={key + index + i}
                  />
               );
            })}
         {tableSettings.rowActions && tableSettings.stickyRowActions && (
            <div
               role="cell"
               className="ecl-table-cell button-cell"
               style={{
                  width: "45px",
                  minWidth: "45px",
               }}
            >
               <ECLDropDown
                  containerId={"table-container-" + instanceId}
                  menuWidth={175}
                  trigger={
                     <ECLThemeImage
                        alt={translate("Row action trigger")}
                        className="default-trigger-image"
                        fontAwesome="ellipsis-vertical"
                     />
                  }
               >
                  {tableSettings.rowActionsConstraint &&
                  tableSettings.rowActionsConstraint(index) === false ? (
                     <p>{tableSettings.rowActionsFallback}</p>
                  ) : (
                     tableSettings.rowActions.map((r, i) => {
                        if (
                           r.constraint !== undefined &&
                           r.constraint(index) === false
                        ) {
                           return null;
                        }
                        return (
                           <button
                              key={r + i}
                              style={{
                                 width: "200px",
                              }}
                              onClick={(e) => {
                                 e.preventDefault();
                                 r.action(index);
                              }}
                           >
                              {translate(r.label)}
                           </button>
                        );
                     })
                  )}
               </ECLDropDown>
            </div>
         )}
      </div>
   );
}
